import { useEffect, useRef } from 'react';
import { isEmpty } from '@witmetrics/utils/misc';
import { useFilesFromIdArray } from '@witmetrics/data-store';
import { useLoadedFiles } from '@/providers/LoadedFilesProvider';
import { useScene } from '@/providers/SceneProvider';
import { getLoadedScan } from '@/utils/files';
import LoopingEllipsis from '@/components/LoopingEllipsis';
import Scene from '@/components/Scene';
import { classes } from './utils';

export type ViewerContentProps = {
  isLoading: boolean;
  openFileIds: number[];
};

export default function ViewerContent({
  isLoading,
  openFileIds,
}: ViewerContentProps) {
  const currentFileIdsRef = useRef<number[]>([]);
  const openFiles = useFilesFromIdArray(openFileIds);
  const { loadedFiles } = useLoadedFiles();
  const { addToScene, removeFromSceneByFileId, getScene } = useScene();

  useEffect(() => {
    handleUpdateScene();
  }, [openFileIds, loadedFiles]);

  const handleUpdateScene = () => {
    // TODO: Removing files
    const removedFileIds = currentFileIdsRef.current.filter(
      (id) => !openFileIds.includes(id)
    );
    const newFileIds = openFileIds.filter(
      (id) => !currentFileIdsRef.current.includes(id)
    );
    // TODO
    for (const fileId of removedFileIds) {
      removeFromSceneByFileId(fileId);
    }
    const loadedScans = openFiles.map((f) => getLoadedScan(f, loadedFiles));
    loadedScans.forEach((scan) => {
      // if (scan) addToScene([centerObjects([scan])], false);
      if (scan) addToScene([scan], false);
    });
    currentFileIdsRef.current = openFileIds;
  };

  const renderMessage = () => {
    if (isLoading) {
      return (
        <div className={classes.message}>
          Loading file(s)
          <LoopingEllipsis />
        </div>
      );
    } else if (isEmpty(openFileIds)) {
      return <div className={classes.message}>Select a file</div>;
    }
    return null;
  };

  const renderViewer = () => {
    return null; // TODO: Currently assuming there's no non-scan files
    // eslint-disable-next-line witmetrics/no-multiline-comments
    /* if (isLoading || !openFile) return null;
    // let viewer: ReactElement | null = null;
    // if (isImage(openFile.name)) {
    //   const image = getLoadedImage(openFile, loadedFiles);
    //   if (image) {
    //     viewer = <ImageViewer src={image} />;
    //   }
    // } else if (isPdf(openFile.name)) {
    //   const pdf = getLoadedPdf(openFile, loadedFiles);
    //   if (pdf) viewer = <PdfViewer src={pdf} />;
    // } else if (isVideo(openFile.name)) {
    //   const video = getLoadedVideo(openFile, loadedFiles);
    //   if (video) viewer = <VideoViewer src={video} />;
    // }
    // return viewer ? <div className={classes.media}>{viewer}</div> : null;
     */
  };

  return (
    <div className={classes.wrapper}>
      {renderMessage()}
      {renderViewer()}
      <Scene className={classes.scene} />
    </div>
  );
}
